import { render, staticRenderFns } from "./ShareViewCard.vue?vue&type=template&id=00ba1196&"
import script from "./ShareViewCard.vue?vue&type=script&lang=ts&"
export * from "./ShareViewCard.vue?vue&type=script&lang=ts&"
import style0 from "./ShareViewCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports